// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setSeconds as fn } from "../setSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setSeconds = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setSeconds;
